<div class="monthpicker">
  <div class="card">
    <div class="card-header bg-light bg-opacity-10">
      <div class="d-flex align-items-center justify-content-between">
        <button type="button" class="btn mr-auto" (click)="decrement()">
          <i class="fas fa-chevron-left"></i>
        </button>
        <button type="button" class="btn link" (click)="toggleShowYears()">
          {{ model.selectedYearText }}
        </button>
        <button type="button" class="btn ml-auto" (click)="increment()">
          <i class="fas fa-chevron-right"></i>
        </button>
      </div>
    </div>
    <div class="card-body">
      <div class="row" *ngIf="!isShowYears; else yearsChoice">
        <div
          class="col-4 text-center mb-1"
          *ngFor="let month of model.months; let i = index"
        >
          <div class="monthpicker-cell text-center">
            <button
              type="button"
              class="btn px-2 py-1"
              [ngClass]="{
                'btn-primary': isSelectedMonth(i)
              }"
              [disabled]="isDisabled(i)"
              (click)="selectMonth(i)"
            >
              {{ month | titlecase }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <ng-template #yearsChoice>
      <div class="row">
        <div class="col col-4 mb-1" *ngFor="let year of years; let i = index">
          <div class="monthpicker-cell">
            <button
              type="button"
              class="btn px-2 py-1"
              [ngClass]="{
                'btn-primary': isSelectedYear(year)
              }"
              [disabled]="isDisabledYear(year)"
              (click)="selectYear(year)"
            >
              {{ year }}
            </button>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>
